import dayBouncyDaylight from '../assets/bgm/pedometer/day-bouncy-daylight.mp3';
import daySunlitPaws from '../assets/bgm/pedometer/day-sunlit-paws.mp3';
import nightMidnightParkWalk from '../assets/bgm/pedometer/night-midnight-park-walk.mp3';
import nightMoonflowerPaws from '../assets/bgm/pedometer/night-moonflower-paws.mp3';

const STORAGE_KEY = 'pedometer-bgm-enabled';
const VOLUME = 0.5;

const DAY_TRACKS = [daySunlitPaws, dayBouncyDaylight];
const NIGHT_TRACKS = [nightMidnightParkWalk, nightMoonflowerPaws];

let audio = null;
let loadedNight = null;
/** 현재 플레이리스트(낮/밤) 안에서의 순번 */
let trackIndex = 0;

function tracksFor(night) {
  return night ? NIGHT_TRACKS : DAY_TRACKS;
}

function ensureAudio() {
  if (audio) return audio;

  audio = new Audio();
  audio.loop = false;
  audio.addEventListener('ended', () => {
    const tracks = tracksFor(loadedNight);
    if (!tracks.length || !audio) return;
    trackIndex = (trackIndex + 1) % tracks.length;
    audio.src = tracks[trackIndex];
    audio.volume = VOLUME;
    audio.play().catch(() => {
      // 일시정지·정책 등으로 이어서 재생 실패 시 무시
    });
  });
  return audio;
}

/** 미설정이면 기본 ON. 사용자가 끈 적('0')만 OFF로 본다. */
export function loadBgmPreference() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw == null) {
      return true;
    }
    return raw === '1';
  } catch (error) {
    return true;
  }
}

export function saveBgmPreference(enabled) {
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0');
  } catch (error) {
    // private mode 등
  }
}

/** 끄고 켠 상태에서는 mp3를 받지 않도록, 첫 재생 때 Audio를 만든다 */
export async function playBgm(night) {
  const el = ensureAudio();
  const tracks = tracksFor(night);
  if (!tracks.length) return false;

  // 낮↔밤 전환 시에만 해당 리스트 첫 곡부터 (같은 모드면 이어서 재생)
  if (loadedNight !== night) {
    loadedNight = night;
    trackIndex = 0;
    el.src = tracks[0];
  }

  el.volume = VOLUME;
  try {
    await el.play();
    return true;
  } catch (error) {
    // 사용자 제스처 전이면 브라우저가 막는다
    return false;
  }
}

export function pauseBgm() {
  audio?.pause();
}

export function stopBgm() {
  if (!audio) return;
  audio.pause();
  audio.currentTime = 0;
  loadedNight = null;
  trackIndex = 0;
}
